'use strict';

export default class AdminController {
  users: Object[];
  roles = ['shop', 'viewer', 'manager', 'admin'];
  /*@ngInject*/
  constructor(User, private Shop) {
    // Use the User $resource to fetch all users
    this.users = User.query();
  }

  delete(user) {
    user.$remove();
    this.users.splice(this.users.indexOf(user), 1);
  }
  changeRole(user) {
    user.$role().then((res) => {
      // this.status.addSuccess();
    }).catch(error => {
      // this.status.addError(error.data);
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.ts